import { gql } from '@apollo/client';

export const GET_VEHICLE_AND_MODEL_BY_DRIVER_ID = gql`
    query GetVehicleAndModelByDriverId($driverId: Long!) {
        getVehicleAndModelByDriverId(driverId: $driverId) {
            vehicleId
            vehicleModelId
            vehicleTypeId
            vehicleTypeName
            vehicle {
                id
                vehicleNumber
                licensePlate
                status
            }
            vehicleModel {
                id
                name
                status
            }
        }
    }
`;

export interface VehicleAndModelType {
    vehicleId: number;
    vehicleModelId: number;
    vehicleTypeId?: number;
    vehicleTypeName?: string;
    vehicle: {
        id: number;
        vehicleNumber: string;
        licensePlate: string;
        status: number;
    };
    vehicleModel: {
        id: number;
        name: string;
        status: number;
    } | null;
}

export interface GetVehicleAndModelByDriverIdResponse {
    getVehicleAndModelByDriverId: VehicleAndModelType | null;
}

